<template>
  <v-container class="google-auth-login">
    <v-row>
      <v-col sm="12">
        <v-btn color="primary" @click="loginWithGoogle">Login with Google</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Auth } from 'aws-amplify'

export default {
  name: 'GoogleAuthLogin',

  methods: {
    loginWithGoogle () {
      try {
        Auth.federatedSignIn({ provider: 'Google' })
      } catch (err) {
        console.log('[DEVING] ERR =>', err)
      }
    }
  }
}
</script>

<style scoped>
</style>
